// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

// Custom
import { DocumentModel, DocumentModelDTO } from "./DocumentModel";
import { DocumentCategoryType } from "../Enums/DocumentCategoryType";

export class DocumentsModel extends ModelBase<DocumentsModel, DocumentsModelDTO> {
    // #region Properties

    @observable
    public categoryName = "";

    @observable
    public documents = observable<DocumentModel>([]);

    @observable
    public type: number | null = null;

    @observable
    public canDisplay = false;

    @action
    public setCanDisplay = (value: boolean): void => {
        this.canDisplay = value;
    };
    // #endregion Properties

    @computed
    public get documentTitle() {
        let documentTypeTitle = this.categoryName;

        if (this.type) {
            if (this.type in DocumentCategoryType) {
                documentTypeTitle = DocumentCategoryType[this.type].split(/(?=[A-Z])/).join(" ");
            }
        }

        return documentTypeTitle;
    }

    @action
    public fromDto = (dto: DocumentsModelDTO): void => {
        this.categoryName = dto.categoryName;
        this.type = dto.type;

        for (const document of dto.documents) {
            const documentModel = new DocumentModel();

            documentModel.fromDto(document);

            this.documents.push(documentModel);
        }
    };

    public toDto = (): DocumentsModelDTO[] => {
        throw "toDto is not supported";
    };
}

export interface DocumentsModelDTO {
    categoryName: string;
    documents: DocumentModelDTO[];
    type: number | null;
}
